/*
 * MOCK DE DADOS DO BOARD
 *
 * Simula o payload normalizado que o serviço Board entregará ao consumidor.
 * Mantém dados e semântica do exemplo fora da configuração visual do tutorial.
 *
 * IMPORTANTE: level é propriedade do CardType, não uma inferência pelo label.
 * Vários tipos podem compartilhar o mesmo nível hierárquico.
 * Ícone e cor são escolhas visuais independentes do CardType; a cor chega como
 * valor visual selecionado, não como semântica de negócio.
 */

const boardData = {
  title: 'Núcleo P Team',
  description: 'Projetos / Board',
  levels: [
    { value: 4, label: 'Epic', icon: 'crown' },
    { value: 3, label: 'Feature', icon: 'layer-group' },
    { value: 2, label: 'Story', icon: 'book-open' },
    { value: 1, label: 'Task', icon: 'list-check' },
  ],
  iterations: [
    { id: 'sprint-1', value: 'sprint-1', label: 'Sprint 1' },
    { id: 'sprint-2', value: 'sprint-2', label: 'Sprint 2' },
    { id: 'sprint-3', value: 'sprint-3', label: 'Sprint 3' },
  ],
  statuses: [
    { id: 'new', label: 'To Do', level: 4, color: 'to-do' },
    { id: 'in_progress', label: 'In Progress', level: 4, color: 'in-progress' },
    { id: 'review', label: 'Review', level: 4, color: 'review' },
    { id: 'closed', label: 'Done', level: 4, color: 'done' },
    { id: 'new', label: 'To Do', level: 3, color: 'to-do' },
    { id: 'in_progress', label: 'In Progress', level: 3, color: 'in-progress' },
    { id: 'review', label: 'Review', level: 3, color: 'review' },
    { id: 'closed', label: 'Done', level: 3, color: 'done' },
    { id: 'new', label: 'To Do', level: 2, color: 'to-do' },
    { id: 'in_progress', label: 'In Progress', level: 2, color: 'in-progress' },
    { id: 'review', label: 'Review', level: 2, color: 'review' },
    { id: 'closed', label: 'Done', level: 2, color: 'done' },
    { id: 'new', label: 'To Do', level: 1, color: 'to-do' },
    { id: 'in_progress', label: 'In Progress', level: 1, color: 'in-progress' },
    { id: 'review', label: 'Review', level: 1, color: 'review' },
    { id: 'closed', label: 'Done', level: 1, color: 'done' },
  ],
  cardTypes: [
    {
      id: 'epic',
      label: 'Epic',
      level: 4,
      icon: 'crown',
      color: '#9B26AF',
      fields: [
        { key: 'assignedTo', label: 'Responsável', type: 'user' },
        { key: 'tags', label: 'Tags', type: 'tags' },
      ],
    },
    {
      id: 'feature',
      label: 'Feature',
      level: 3,
      icon: 'layer-group',
      color: '#00A8E8',
      fields: [
        { key: 'assignedTo', label: 'Responsável', type: 'user' },
        { key: 'tags', label: 'Tags', type: 'tags' },
        { key: 'parent', label: 'Pertence a', type: 'relation', config: { source: 'cards', level: 'parent' } },
      ],
    },
    {
      id: 'story',
      label: 'User Story',
      level: 2,
      icon: 'book-open',
      color: '#0084FF',
      fields: [
        { key: 'assignedTo', label: 'Responsável', type: 'user' },
        { key: 'storyPoints', label: 'Story Points', type: 'number' },
        { key: 'tags', label: 'Tags', type: 'tags' },
        { key: 'iteration', label: 'Iteração', type: 'combo', config: { source: 'iterations' } },
        { key: 'parent', label: 'Pertence a', type: 'relation', config: { source: 'cards', level: 'parent' } },
        { key: 'predecessor', label: 'Antecessor', type: 'relation', config: { source: 'cards', level: 'same' } },
      ],
    },
    {
      id: 'enabler',
      label: 'Enabler',
      level: 2,
      icon: 'gears',
      color: '#00CC6A',
      fields: [
        { key: 'assignedTo', label: 'Responsável', type: 'user' },
        { key: 'tags', label: 'Tags', type: 'tags' },
        { key: 'iteration', label: 'Iteração', type: 'combo', config: { source: 'iterations' } },
        { key: 'parent', label: 'Pertence a', type: 'relation', config: { source: 'cards', level: 'parent' } },
        { key: 'predecessor', label: 'Antecessor', type: 'relation', config: { source: 'cards', level: 'same' } },
      ],
    },
    {
      id: 'bug',
      label: 'Bug',
      level: 2,
      icon: 'bug',
      color: '#FF5630',
      fields: [
        { key: 'assignedTo', label: 'Responsável', type: 'user' },
        { key: 'tags', label: 'Tags', type: 'tags' },
      ],
    },
    {
      id: 'poc',
      label: 'PoC',
      level: 2,
      icon: 'flask',
      color: '#4DEA5C',
      fields: [
        { key: 'assignedTo', label: 'Responsável', type: 'user' },
        { key: 'tags', label: 'Tags', type: 'tags' },
        { key: 'iteration', label: 'Iteração', type: 'combo', config: { source: 'iterations' } },
      ],
    },
    {
      id: 'technical-debt',
      label: 'Technical Debt',
      level: 2,
      icon: 'screwdriver-wrench',
      color: '#FF6E00',
      fields: [
        { key: 'assignedTo', label: 'Responsável', type: 'user' },
        { key: 'storyPoints', label: 'Story Points', type: 'number' },
        { key: 'tags', label: 'Tags', type: 'tags' },
        { key: 'parent', label: 'Pertence a', type: 'relation', config: { source: 'cards', level: 'parent' } },
      ],
    },
    {
      id: 'task',
      label: 'Task',
      level: 1,
      icon: 'list-check',
      color: '#FFC400',
      fields: [
        { key: 'assignedTo', label: 'Responsável', type: 'user' },
        { key: 'tags', label: 'Tags', type: 'tags' },
      ],
    },
  ],
  swimlanesByLevel: {
    2: [
      {
        id: 'primary',
        label: 'Faixa principal',
        color: '#0084FF',
        order: 0,
        isPrimary: true,
      },
      {
        id: 'secondary',
        label: 'Faixa secundária',
        color: '#FFC400',
        order: 1,
      },
    ],
  },
  columns: [
    {
      key: 'new',
      label: 'To Do',
      cards: [
        {
          id: 'epic-1',
          cardTypeId: 'epic',
          typeLabel: 'Epic',
          typeLevel: 4,
          typeIcon: 'crown',
          typeColor: '#9B26AF',
          title: 'Evoluir a experiência compartilhada de DataViews',
          dueLabel: '30 set',
          dueState: 'success',
          responsible: { initials: 'WP', name: 'Wellington Pereira' },
          tags: [{ label: 'DataViews', color: 1 }],
        },
        {
          id: 'story-1',
          cardTypeId: 'story',
          typeLabel: 'User Story',
          typeLevel: 2,
          typeIcon: 'book-open',
          typeColor: '#0084FF',
          title: 'Permitir configurar os campos exibidos no formulário do card',
          storyPoints: 8,
          iteration: 'sprint-2',
          parent: 'feature-1',
          predecessor: 'enabler-1',
          dueLabel: '12 set',
          dueState: 'success',
          responsible: { initials: 'WP', name: 'Wellington Pereira' },
          tags: [
            { label: 'MVP', color: 1 },
            { label: 'UX', color: 4 },
          ],
          metadata: [
            { key: 'storyPoints', label: 'Story Points', value: 8 },
            { key: 'iteration', label: 'Iteração', value: 'Sprint 2' },
            { key: 'parent', label: 'Pertence a', value: 'Entregar pesquisa e filtros compartilhados no Board' },
            { key: 'predecessor', label: 'Antecessor', value: 'Preparar infraestrutura compartilhada para novos tipos de campos' },
          ],
        },
        {
          id: 'enabler-1',
          cardTypeId: 'enabler',
          typeLabel: 'Enabler',
          typeLevel: 2,
          typeIcon: 'gears',
          typeColor: '#00CC6A',
          title: 'Preparar infraestrutura compartilhada para novos tipos de campos',
          iteration: 'sprint-2',
          parent: 'feature-1',
          predecessor: 'story-1',
          dueLabel: 'Hoje',
          dueState: 'warning',
          visualState: 'warning',
          responsible: { initials: 'AC', name: 'Amanda Carvalho' },
          tags: [{ label: 'Atenção', type: 'warning' }],
          metadata: [
            { key: 'iteration', label: 'Iteração', value: 'Sprint 2' },
            { key: 'parent', label: 'Pertence a', value: 'Entregar pesquisa e filtros compartilhados no Board' },
            { key: 'predecessor', label: 'Antecessor', value: 'Permitir configurar os campos exibidos no formulário do card' },
          ],
        },
        {
          id: 'bug-1',
          cardTypeId: 'bug',
          typeLabel: 'Bug',
          typeLevel: 2,
          typeIcon: 'bug',
          typeColor: '#FF5630',
          title: 'Card sem responsável para validar o estado mínimo e ausência de avatar',
          dueLabel: 'Vencido há 3 dias',
          dueState: 'danger',
          visualState: 'danger',
          tags: [{ label: 'Bloqueado', type: 'blocked' }],
          blocked: true,
        },
      ],
    },
    {
      key: 'in_progress',
      label: 'In Progress',
      wipLimit: 2,
      cards: [
        {
          id: 'story-2',
          swimlaneId: 'primary',
          cardTypeId: 'story',
          typeLabel: 'User Story',
          typeLevel: 2,
          typeIcon: 'book-open',
          typeColor: '#0084FF',
          title: 'Filtrar o Board por nível mantendo o workflow configurado para a visão',
          storyPoints: 5,
          iteration: 'sprint-2',
          parent: 'feature-1',
          predecessor: 'story-1',
          dueLabel: '8 set',
          dueState: 'success',
          responsible: { initials: 'RF', name: 'Rafael Ferreira' },
          tags: [{ label: 'Board', color: 1 }],
          metadata: [
            { key: 'storyPoints', label: 'Story Points', value: 5 },
            { key: 'iteration', label: 'Iteração', value: 'Sprint 2' },
            { key: 'parent', label: 'Pertence a', value: 'Entregar pesquisa e filtros compartilhados no Board' },
            { key: 'predecessor', label: 'Antecessor', value: 'Permitir configurar os campos exibidos no formulário do card' },
          ],
        },
        {
          id: 'poc-1',
          swimlaneId: 'secondary',
          cardTypeId: 'poc',
          typeLabel: 'PoC',
          typeLevel: 2,
          typeIcon: 'flask',
          typeColor: '#4DEA5C',
          title: 'Validar comportamento visual com título propositalmente maior para testar quebra de linha e densidade do card sem alterar a largura da coluna',
          iteration: 'sprint-3',
          dueLabel: '15 set',
          dueState: 'success',
          responsible: { initials: 'MN', name: 'Marina Nunes' },
          tags: [
            { label: 'PoC', color: 9 },
            { label: 'Visual', color: 4 },
            { label: 'EP', color: 7 },
          ],
          metadata: [
            { key: 'iteration', label: 'Iteração', value: 'Sprint 3' },
          ],
        },
      ],
    },
    {
      key: 'review',
      label: 'Review',
      wipLimit: 2,
      cards: [
        {
          id: 'feature-1',
          cardTypeId: 'feature',
          typeLabel: 'Feature',
          typeLevel: 3,
          typeIcon: 'layer-group',
          typeColor: '#00A8E8',
          title: 'Entregar pesquisa e filtros compartilhados no Board',
          parent: 'epic-1',
          dueLabel: '18 set',
          dueState: 'success',
          responsible: { initials: 'RF', name: 'Rafael Ferreira' },
          tags: [{ label: 'Board', color: 1 }],
          metadata: [
            { key: 'parent', label: 'Pertence a', value: 'Evoluir a experiência compartilhada de DataViews' },
          ],
        },
        {
          id: 'story-3',
          swimlaneId: 'primary',
          cardTypeId: 'technical-debt',
          typeLabel: 'Technical Debt',
          typeLevel: 2,
          typeIcon: 'screwdriver-wrench',
          typeColor: '#FF6E00',
          title: 'Revisar tokens semânticos compartilhados por tags, status e regras visuais',
          storyPoints: 3,
          parent: 'feature-1',
          dueLabel: '10 set',
          dueState: 'success',
          responsible: { initials: 'JS', name: 'João Silva' },
          tags: [{ label: 'Revisão', type: 'review' }],
          metadata: [
            { key: 'storyPoints', label: 'Story Points', value: 3 },
            { key: 'parent', label: 'Pertence a', value: 'Entregar pesquisa e filtros compartilhados no Board' },
          ],
        },
      ],
    },
    {
      key: 'closed',
      label: 'Done',
      cards: [
        {
          id: 'task-1',
          cardTypeId: 'task',
          typeLabel: 'Task',
          typeLevel: 1,
          typeIcon: 'list-check',
          typeColor: '#FFC400',
          title: 'Ajustar cobertura automatizada do filtro de nível',
          dueLabel: 'Concluído',
          dueState: 'success',
          responsible: { initials: 'JS', name: 'João Silva' },
          tags: [{ label: 'Testes', color: 7 }],
        },
      ],
    },
  ],
};

export default boardData;
